import styled from "styled-components";

export const StyledContact = styled.div`
  background-color: ${({ theme }) => theme.dyphiDarkGray};
  color: ${({ theme }) => theme.dyphiInactive};
  padding: ${(props) =>
    props.isDesktop ? "9vh 8.3333vw" : "7vh 6vw"};

  font-family: NanumSquare;
  font-style: normal;

  .footer {
    display: flex;
    flex-direction: column;
    align-items: ${(props) => (props.isDesktop ? "flex-start" : "center")};
    text-align: ${(props) => (props.isDesktop ? "left" : "center")};
    letter-spacing: 0.03rem;

    .links {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-bottom: 2.4rem;

      .text {
        font-size: 1rem;
        line-height: 1.6rem;
        font-weight: 700;
        color: ${({ theme }) => theme.dyphiWhite};
        text-decoration: none;
      }

      .text:hover {
        text-decoration: underline;
      }

      .sep {
        padding: 0 0.7rem;
        opacity: 0.35;
      }
    }

    .company {
      font-weight: 800;
      font-size: 1.35rem;
      line-height: 2rem;
      letter-spacing: 0.05rem;
      color: ${({ theme }) => theme.dyphiWhite};
      margin-bottom: 1.3rem;
    }

    .legal {
      display: flex;
      flex-direction: column;
      align-items: ${(props) => (props.isDesktop ? "flex-start" : "center")};

      .legal-line {
        display: flex;
        flex-wrap: wrap;
        justify-content: ${(props) =>
          props.isDesktop ? "flex-start" : "center"};
        align-items: center;
        font-size: 0.95rem;
        line-height: 1.9rem;
        word-break: keep-all;

        .dot {
          padding: 0 0.55rem;
          opacity: 0.45;
        }

        a {
          color: inherit;
          text-decoration: none;
        }

        a:hover {
          color: ${({ theme }) => theme.dyphiWhite};
        }
      }
    }

    .copyright {
      font-size: 0.85rem;
      line-height: 1.8rem;
      margin-top: 1.8rem;
      opacity: 0.6;
    }
  }
`;
